import React from "react"
import { FormText, Input, Label, Table } from "reactstrap"
import { useTranslation } from "react-i18next"

// TEMPORARY — 4 → 6 digit OTP rollout for the tenant's customer and rider apps
// (not the portal). Super admin only, part of the add/edit tenant form.
//   off           → 4 digits for everyone
//   new_apps_only → 6 digits for app versions that support it, 4 for old versions
//   everyone      → 6 digits for everyone
// Remove once every flow is on "everyone" and the 4-digit code is deleted.
export const OTP_LENGTH_MODES = [
  { value: "off", label: "Off (4 digits)" },
  { value: "new_apps_only", label: "New apps only" },
  { value: "everyone", label: "Everyone (6 digits)" },
]

export const OTP_LENGTH_FLOWS = [
  { key: "customerLogin", app: "customer", label: "Customer login / sign-up" },
  { key: "customerForgotPassword", app: "customer", label: "Customer forgot password" },
  { key: "customerChangeMobile", app: "customer", label: "Customer change mobile number" },
  { key: "riderLogin", app: "rider", label: "Rider login" },
  { key: "pickupOtp", app: "rider", label: "Pickup OTP (sent to the rider, optional)" },
  {
    key: "deliveryOtp",
    app: "rider",
    label: "Delivery OTP (customer receives, rider enters)",
  },
]

/** Every flow with a mode; flows never saved are "off". */
export const normalizeOtpLengthValues = (saved = {}) =>
  OTP_LENGTH_FLOWS.reduce(
    (acc, flow) => ({ ...acc, [flow.key]: saved?.[flow.key] || "off" }),
    {}
  )

const TenantOtpLengthFields = ({ value, onChange, showRiderFlows, disabled }) => {
  const { t } = useTranslation()
  const values = normalizeOtpLengthValues(value)
  const visibleFlows = OTP_LENGTH_FLOWS.filter(
    flow => showRiderFlows || flow.app !== "rider"
  )

  return (
    <div className="border rounded p-3 mb-3">
      <h6 className="mb-1">{t("OTP Length (4 to 6 digits)")}</h6>
      <FormText color="muted" className="d-block mb-2">
        {t(
          "Choose the OTP length for each customer and rider app flow. Off: everyone gets 4 digits. New apps only: app versions that support 6 digits get 6, older versions keep 4. Everyone: everyone gets 6 digits."
        )}
      </FormText>
      <div className="table-responsive">
        <Table className="align-middle mb-0" size="sm">
          <thead>
            <tr>
              <th>{t("Flow")}</th>
              {OTP_LENGTH_MODES.map(mode => (
                <th key={mode.value} className="text-center">
                  {t(mode.label)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleFlows.map(flow => (
              <tr key={flow.key}>
                <td>{t(flow.label)}</td>
                {OTP_LENGTH_MODES.map(mode => {
                  const id = `otp-length-${flow.key}-${mode.value}`
                  return (
                    <td key={mode.value} className="text-center">
                      <Input
                        type="radio"
                        id={id}
                        name={`otp-length-${flow.key}`}
                        value={mode.value}
                        checked={values[flow.key] === mode.value}
                        disabled={disabled}
                        onChange={() => onChange({ ...values, [flow.key]: mode.value })}
                      />
                      <Label htmlFor={id} className="visually-hidden">
                        {`${t(flow.label)}: ${t(mode.label)}`}
                      </Label>
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <FormText color="muted" className="d-block mt-2">
        {t(
          "Changes apply within a minute. A code that was already sent keeps working with its own length until it expires. Delivery OTP uses 6 digits on New apps only when both the customer's and the rider's app support it."
        )}
      </FormText>
    </div>
  )
}

export default TenantOtpLengthFields
